<template>
  <div class="risk-analysis-charts">
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Risk Category Distribution</v-card-title>
          <v-card-text>
            <canvas ref="categoryChart"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Risk Impact Distribution</v-card-title>
          <v-card-text>
            <canvas ref="impactChart"></canvas>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Chart from 'chart.js/auto';

export default defineComponent({
  name: 'RiskAnalysisPieCharts',
  props: {
    riskData: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      categoryChart: null,
      impactChart: null
    };
  },
  mounted() {
    this.initializeCharts();
  },
  methods: {
    initializeCharts() {
      this.createCategoryChart();
      this.createImpactChart();
    },
    createCategoryChart() {
      const ctx = this.$refs.categoryChart.getContext('2d');
      const categoryData = this.processRiskCategories();
      
      this.categoryChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: Object.keys(categoryData),
          datasets: [{
            data: Object.values(categoryData),
            backgroundColor: [
              '#FF6384',
              '#36A2EB',
              '#FFCE56',
              '#4BC0C0',
              '#9966FF'
            ]
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom'
            },
            title: {
              display: true,
              text: 'Risk Categories'
            }
          }
        }
      });
    },
    createImpactChart() {
      const ctx = this.$refs.impactChart.getContext('2d');
      const impactData = this.processRiskImpacts();
      
      this.impactChart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: Object.keys(impactData),
          datasets: [{
            data: Object.values(impactData),
            backgroundColor: [
              '#FF6384',
              '#36A2EB',
              '#FFCE56'
            ]
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom'
            },
            title: {
              display: true,
              text: 'Risk Impact Levels'
            }
          }
        }
      });
    },
    processRiskCategories() {
      const categories = {};
      this.riskData.forEach(risk => {
        categories[risk.category] = (categories[risk.category] || 0) + 1;
      });
      return categories;
    },
    processRiskImpacts() {
      const impacts = {
        'High': 0,
        'Medium': 0,
        'Low': 0
      };
      this.riskData.forEach(risk => {
        impacts[risk.impact]++;
      });
      return impacts;
    }
  },
  watch: {
    riskData: {
      handler() {
        if (this.categoryChart) {
          this.categoryChart.destroy();
        }
        if (this.impactChart) {
          this.impactChart.destroy();
        }
        this.initializeCharts();
      },
      deep: true
    }
  },
  beforeUnmount() {
    if (this.categoryChart) {
      this.categoryChart.destroy();
    }
    if (this.impactChart) {
      this.impactChart.destroy();
    }
  }
});
</script>

<style scoped>
.risk-analysis-charts {
  padding: 20px;
}
.v-card {
  margin-bottom: 20px;
}
canvas {
  max-height: 300px;
}
</style> 